import Route from './Route'

export default Route
// eslint-disable-next-line import/export
export * from './Route'
